import { useTranslation } from "react-i18next";
import { Save } from "lucide-react";
import Button from "../../../../../components/shared/Button";

function Header({ name, isLoading }: { name: string, isLoading: boolean }) {
    const { t } = useTranslation();

    return (
        <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-border tw-py-2 tw-px-3 tw-mb-4">
            <h1 className="tw-font-bold">{t(name)}</h1>

            <Button
                type="submit"
                // variant="dark"
                icon={<Save />}
                loading={isLoading}
                disabled={isLoading}
            >
                {t("save")}
            </Button>
        </div>
    );
}

export default Header;
